export enum ClaimRequestType {
    HEALTH = 'health',
    PREVENTION = 'prevention',
}
